var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5765 0.436487C14.2014 0.0514486 13.6462 -0.0919971 13.1284 0.0589983L1.056 3.56964C0.509774 3.72139 0.122615 4.15702 0.0183226 4.71041C-0.088221 5.27363 0.283931 5.98859 0.77013 6.28756L4.54493 8.60761C4.93208 8.84542 5.43179 8.78578 5.75217 8.46265L10.0747 4.11323C10.2923 3.88673 10.6524 3.88673 10.87 4.11323C11.0876 4.33217 11.0876 4.68701 10.87 4.9135L6.53999 9.26368C6.21886 9.58606 6.15884 10.0881 6.39518 10.4777L8.70163 14.2903C8.97174 14.7433 9.43693 15 9.94714 15C10.0072 15 10.0747 15 10.1347 14.9924C10.72 14.917 11.1851 14.5168 11.3577 13.9506L14.9367 1.89359C15.0942 1.38021 14.9517 0.821525 14.5765 0.436487",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/inviteIcon.b85d318433aac59de332d16863cb915f.svg";
export { ForwardRef as ReactComponent };